import {useEffect, useRef, useState} from 'react';

import {Tooltip, Typography, Box, Grid} from '@mui/material';
import {grey} from '@mui/material/colors';
import muiStyled from '@mui/material/styles/styled';
import {useWindowSize} from '@uidotdev/usehooks';
import {bool} from 'prop-types';

import {PROJECTS_VIEW_TYPES} from '../../../../const';
import useProjects from '../../../../hooks/providers/useProjects';
import {projectShape} from '../../../../proptypes-shapes';

const StyledDash = muiStyled(Box)(() => ({
  fontSize: 10,
  color: grey[500],
  margin: '0 2px',
  display: 'inline'
}));

const SmallText = muiStyled(Typography)(() => ({
  fontSize: 12,
  color: grey[400],
  whiteSpace: 'nowrap',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: 1.2
}));

const TinyText = muiStyled(Typography)(() => ({
  fontSize: 10,
  color: grey[400],
  lineHeight: 1
}));

const LastActualizationInformation = ({project, hasStartingSeparator = false}) => {
  const ref = useRef(null);
  const [isEllipsed, setIsEllipsed] = useState(false);

  const {width} = useWindowSize();
  const {viewType} = useProjects();
  const isListView = viewType === PROJECTS_VIEW_TYPES.list;

  const pieceDate = project.last_piece_date;
  const lastUpdate = project.last_update;

  useEffect(() => {
    if (ref.current) {
      setIsEllipsed(ref.current.scrollWidth > ref.current.clientWidth);
    }
  }, [pieceDate, lastUpdate, width]);

  if (isListView) {
    const tooltipTitle = isEllipsed ? (
      <Box>
        {pieceDate} - {lastUpdate}
      </Box>
    ) : undefined;

    return (
      <Tooltip placement="top" title={tooltipTitle}>
        <SmallText ref={ref}>
          {hasStartingSeparator && <StyledDash>-</StyledDash>}
          {pieceDate}
          <StyledDash>-</StyledDash>
          {lastUpdate}
        </SmallText>
      </Tooltip>
    );
  }

  return (
    <Grid flex={1} container direction="column" marginTop="1px" gap={0.75}>
      <TinyText>{pieceDate}</TinyText>
      <TinyText>{lastUpdate}</TinyText>
    </Grid>
  );
};

LastActualizationInformation.propTypes = {
  project: projectShape.isRequired,
  hasStartingSeparator: bool
};

export default LastActualizationInformation;
